import type { PartnerAdminsBankAccount } from '@fukuri-admins/apis/client/gen/model';

type ISelectLatestBankAccount = (
  bankAccounts: PartnerAdminsBankAccount[]
) => PartnerAdminsBankAccount | undefined;

/**
 * 複数の口座レコードから linked_at が最新の 1 件を返す
 *
 * - 口座レコードが 0 件の場合は undefined を返す
 * - 一覧側 PEN-421 でも同様の選択ロジックが必要になる想定のため純粋関数として切り出している
 */
export const selectLatestBankAccount: ISelectLatestBankAccount = bankAccounts => {
  if (bankAccounts.length === 0) return undefined;

  return bankAccounts.reduce((latest, current) =>
    current.linked_at > latest.linked_at ? current : latest
  );
};
